export enum CookieName {

    AcceptCookie = "acceptCookie",
    BrokerName = "brokerName"
}
